import {
  ADD_MASTER_SUBTASK,
  EDIT_MASTER_SUBTASK,
  GET_MASTER_SUBTASKS,
} from '../../../modules/constants';

export function getMasterSubTasks(value) {
  return {
    type: GET_MASTER_SUBTASKS,
    payload: value,
  };
}

export function addMasterSubTask(payload) {
  return {
    type: ADD_MASTER_SUBTASK,
    payload: { ...payload },
  };
}

export function editMasterSubTask(value) {
  return {
    type: EDIT_MASTER_SUBTASK,
    payload: value,
  };
}
